import React from 'react';

const Update = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Update_a"
        d="M1179.93 98.35a7.35 7.35 0 0 0-5.36-2.35c-4.19 0-7.57 3.58-7.57 8s3.38 8 7.57 8a7.65 7.65 0 0 0 7.33-6h-1.97a5.7 5.7 0 0 1-5.36 4c-3.13 0-5.68-2.69-5.68-6s2.55-6 5.68-6c1.58 0 2.98.69 4 1.78l-3.05 3.22h6.64v-7z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Update_a" transform="translate(-1167 -96)" />
  </svg>
);

export default Update;



// WEBPACK FOOTER //
// ./src/common/icons/Update.js